import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AuthorDateComponent } from './author-date.component'

@NgModule({
  declarations: [AuthorDateComponent],
  imports: [CommonModule],
  exports: [AuthorDateComponent]
})
export class AuthorDateModule {}
